/* Fun Cases: Case Club in the cart.
   Renders into every [data-cc-cart] slot (drawer + cart page):
   - members with issued codes: a collapsible "You have N Case Club codes" bar, each code with Apply
   - members who can afford >= £1: "You've got £N to cash in" with amount chips, an inline confirm,
     POST /apps/case-club/redeem-money, then the new code is applied straight to the cart
   - free-product codes (useUrl -> /products/...): "Apply & pick" applies the code, then opens the product
   - members: an "Earn more" strip (coins this order earns + a rotating quick win)
   - guests (only when the programme is live or previewing): "Join Case Club, earn N coins on this order"
   Applying a code uses the Cart AJAX API (/cart/update.js { discount }) and then re-renders the drawer
   via window.fcCart.refresh() (or reloads the server-rendered cart page).
   Listens for `fc:cart:rendered` (fired by cart.js after every drawer render) so it survives re-renders. */
(function () {
  'use strict';

  var slots = document.querySelectorAll('[data-cc-cart]');
  if (!slots.length) return;

  var PROXY = '/apps/case-club/me';
  var CACHE_KEY = 'cc_cart_me_v1';
  var TTL_MEMBER = 60 * 1000;          // members: re-check codes every minute at most
  var TTL_GUEST = 10 * 60 * 1000;      // guests: only need `live` + rates, so cache longer
  var isCustomer = slots[0].getAttribute('data-cc-customer') === '1';
  var onCartPage = !!document.querySelector('[data-cart-page]');

  var state = { me: null, cart: null, open: false, busy: '', msg: null, win: 0, loading: null, cash: { open: false, pick: 0, busy: false, msg: null } };
  try { state.open = sessionStorage.getItem('ccx_open') === '1'; } catch (e) {}
  var rotTimer = null;

  /* ---- helpers ---- */
  function preview() { try { return sessionStorage.getItem('cc_preview') || ''; } catch (e) { return ''; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtN(n) { return Number(n || 0).toLocaleString('en-GB'); }
  function upper(s) { return String(s || '').toUpperCase(); }
  function rate() { var c = window.Shopify && window.Shopify.currency; var r = c && Number(c.rate); return r > 0 ? r : 1; }

  function loadMe() {
    if (state.loading) return state.loading;
    var pv = preview();
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.pv === pv && c.cust === isCustomer && Date.now() - c.at < (c.data && c.data.member ? TTL_MEMBER : TTL_GUEST)) {
        state.me = c.data; return Promise.resolve(c.data);
      }
    } catch (e) {}
    state.loading = fetch(PROXY + (pv ? '?preview=' + encodeURIComponent(pv) : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cc ' + r.status); return r.json(); })
      .then(function (j) {
        state.me = j; state.loading = null;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), pv: pv, cust: isCustomer, data: j })); } catch (e) {}
        return j;
      })
      .catch(function () { state.loading = null; state.me = null; return null; });
    return state.loading;
  }

  /* After a redeem, merge the fresh member + vouchers and restart the cache clock. */
  function storeMe(j) {
    state.me = j;
    try { sessionStorage.removeItem(CACHE_KEY); sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), pv: preview(), cust: isCustomer, data: j })); } catch (e) {}
  }
  function withRoot(url) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!url || url.charAt(0) !== '/' || root === '/' || url.indexOf(root) === 0) return url;
    return root + url.slice(1);
  }
  function handleOf(url) { var m = /\/products\/([^\/?#]+)/.exec(url || ''); return m ? decodeURIComponent(m[1]).toLowerCase() : ''; }
  /* A free-product code: its useUrl points at a product page (gift drops and free_product rewards). */
  function productVoucher(v) { return !!handleOf(v && v.useUrl); }
  function productInCart(cart, v) {
    var h = handleOf(v.useUrl);
    return !!h && ((cart && cart.items) || []).some(function (i) { return handleOf(i.url) === h || (i.handle || '').toLowerCase() === h; });
  }
  function onCartUnapplied(cart, code) { return cartCodes(cart).some(function (d) { return !d.applicable && upper(d.code) === upper(code); }); }

  function issued(me) { return ((me && me.vouchers) || []).filter(function (v) { return v.status === 'issued' && v.code; }); }
  function cartCodes(cart) { return ((cart && cart.discount_codes) || []); }
  function isApplied(cart, code) { return cartCodes(cart).some(function (d) { return d.applicable && upper(d.code) === upper(code); }); }

  /* Coins this order earns: subtotal in GBP x pointsPerPound (cart totals are presentment-currency pence). */
  function orderCoins(cart, me) {
    var ppp = Number(me && me.pointsPerPound) || 0;
    if (!cart || !ppp) return 0;
    return Math.floor((cart.total_price / rate()) * ppp / 100);
  }

  /* Quick wins the member hasn't done yet, best first. */
  function quickWins(me) {
    var m = me.member || {}, claimed = m.claimed || [], out = [], per = Number(me.coinsPerPoundOff) || 0;
    if (me.trustpilotPoints && claimed.indexOf('trustpilot') === -1) out.push({ icon: '⭐', text: '+' + fmtN(me.trustpilotPoints) + ' for a Trustpilot review' });
    if (me.birthdayBonus && !m.birthday) out.push({ icon: '🎂', text: '+' + fmtN(me.birthdayBonus) + ' on your birthday' });
    if (me.instagramPoints && claimed.indexOf('instagram') === -1) out.push({ icon: '📸', text: '+' + fmtN(me.instagramPoints) + ' for an Instagram follow' });
    if (me.tiktokPoints && claimed.indexOf('tiktok') === -1) out.push({ icon: '🎵', text: '+' + fmtN(me.tiktokPoints) + ' for a TikTok follow' });
    return out;
  }

  /* ---- render ---- */
  function codeRow(v, cart) {
    var applied = isApplied(cart, v.code), busy = state.busy === upper(v.code);
    var pick = productVoucher(v) && !productInCart(cart, v);
    var sub = [];
    if (v.note) sub.push(esc(v.note));
    if (v.expiresAt) { try { sub.push('Ends ' + new Date(v.expiresAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })); } catch (e) {} }
    var action = (pick && onCartUnapplied(cart, v.code))
      ? '<a class="ccx__apply ccx__apply--pick" href="' + esc(withRoot(v.useUrl)) + '">Pick it</a>' +
        '<button type="button" class="ccx__remove" data-ccx-remove="' + esc(v.code) + '" aria-label="Remove ' + esc(v.name || v.code) + '"' + (busy ? ' disabled' : '') + '>&times;</button>'
      : applied
      ? '<span class="ccx__applied">Applied <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg></span>' +
        '<button type="button" class="ccx__remove" data-ccx-remove="' + esc(v.code) + '" aria-label="Remove ' + esc(v.name || v.code) + '"' + (busy ? ' disabled' : '') + '>&times;</button>'
      : '<button type="button" class="ccx__apply' + (busy ? ' is-loading' : '') + '" data-ccx-apply="' + esc(v.code) + '"' + (pick ? ' data-ccx-pick="' + esc(v.useUrl) + '"' : '') + (state.busy ? ' disabled' : '') + '>' + (busy ? 'Adding' : (pick ? 'Apply &amp; pick' : 'Apply')) + '</button>';
    return '<li class="ccx__code' + (applied ? ' is-applied' : '') + '">' +
      '<div class="ccx__info"><span class="ccx__name">' + esc(v.name || v.code) + '</span>' + (sub.length ? '<span class="ccx__note">' + sub.join(' &middot; ') + '</span>' : '') + '</div>' +
      '<div class="ccx__act">' + action + '</div></li>';
  }

  /* ---- cash in ---- */
  var CHIPS = [1, 2, 5, 10, 20, 50];
  function cashInfo(me, cart) {
    var per = Number(me.coinsPerPoundOff) || 0, bal = (me.member && me.member.balance) || 0;
    var afford = per ? Math.floor(bal / per) : 0;
    var bag = Math.floor((cart.total_price / rate()) / 100);  // whole pounds the bag is worth (after codes already on it)
    return { per: per, bal: bal, afford: afford, bag: bag, max: Math.min(afford, bag) };
  }
  function cashRow(me, cart, uid) {
    var c = cashInfo(me, cart), cs = state.cash;
    if (c.afford < 1) return '';
    var head = '<div class="ccx__cash-head"><span class="ccx__cash-i" aria-hidden="true">💰</span><span class="ccx__cash-t">You&rsquo;ve got <strong>£' + fmtN(c.afford) + '</strong> to cash in</span>' +
      (cs.open ? '' : '<button type="button" class="ccx__apply ccx__apply--sun" data-ccx-cash aria-expanded="false" aria-controls="ccx-cash-' + uid + '">Cash in</button>') + '</div>';
    if (!cs.open) return '<div class="ccx__cash">' + head + '</div>';
    var body;
    if (cs.pick) {
      var cost = cs.pick * c.per;
      body = '<div class="ccx__confirm" role="group" aria-label="Confirm cash in">' +
        '<p class="ccx__confirm-t">Swap <strong>' + fmtN(cost) + ' coins</strong> for <strong>£' + cs.pick + ' off</strong>?</p>' +
        '<p class="ccx__note">You&rsquo;ll have ' + fmtN(c.bal - cost) + ' coins left. We&rsquo;ll pop the code straight on your bag.</p>' +
        '<div class="ccx__confirm-b"><button type="button" class="ccx__apply ccx__apply--sun" data-ccx-cash-go' + (cs.busy ? ' disabled' : '') + '>' + (cs.busy ? 'Cashing in' : 'Yes, cash in') + '</button>' +
        '<button type="button" class="ccx__textbtn" data-ccx-cash-back' + (cs.busy ? ' disabled' : '') + '>Not yet</button></div></div>';
    } else {
      // Set amounts, plus "all of it" when the max isn't already one of them
      var amounts = CHIPS.slice();
      if (c.max > 0 && amounts.indexOf(c.max) === -1) amounts.push(c.max);
      amounts.sort(function (a, b) { return a - b; });
      body = '<p class="ccx__note">' + fmtN(c.per) + ' coins = £1 off. Pick an amount.</p><div class="ccx__chips">' + amounts.map(function (n) {
        var ok = n <= c.max, all = n === c.max && c.max > 0;
        return '<button type="button" class="ccx__chip' + (all ? ' ccx__chip--all' : '') + '" data-ccx-chip="' + n + '"' + (ok ? '' : ' disabled') + '>' + (all ? 'All £' + fmtN(n) : '£' + n) + '</button>';
      }).join('') + '</div>' +
      (c.bag < c.afford ? '<p class="ccx__note">Up to £' + fmtN(Math.max(c.bag, 0)) + ' on this bag, so you don&rsquo;t cash in more than it&rsquo;s worth.</p>' : '') +
      '<button type="button" class="ccx__textbtn" data-ccx-cash-close>Close</button>';
    }
    return '<div class="ccx__cash is-open">' + head + '<div class="ccx__cash-body" id="ccx-cash-' + uid + '">' + body +
      (cs.msg ? '<p class="ccx__msg' + (cs.msg.ok ? ' is-ok' : '') + '" role="status">' + esc(cs.msg.text) + '</p>' : '') + '</div></div>';
  }

  function build(uid) {
    var me = state.me, cart = state.cart;
    if (!me || !cart || !cart.item_count) return '';
    var previewing = !!preview();
    if (!me.live && !previewing) return '';
    var coins = orderCoins(cart, me);

    /* Guest, or logged in but not (yet) a member */
    if (!me.member) {
      if (!coins) return '';
      var joinHref = me.loggedIn ? '/pages/case-club' : '/account/login?return_url=' + encodeURIComponent('/pages/case-club');
      return '<div class="ccx ccx--slim"><a class="ccx__earn" href="' + joinHref + '"><span class="ccx__dot" aria-hidden="true"></span>' +
        '<span class="ccx__earn-t">Join <strong>Case Club</strong> and earn <strong>' + fmtN(coins) + ' coins</strong> on this order</span><span class="ccx__arrow" aria-hidden="true">&rarr;</span></a></div>';
    }

    var codes = issued(me), wins = quickWins(me), html = '';
    if (codes.length) {
      var n = codes.length, appliedN = codes.filter(function (v) { return isApplied(cart, v.code); }).length;
      var label = appliedN
        ? '<strong>' + appliedN + ' of ' + n + '</strong> Case Club code' + (n === 1 ? '' : 's') + ' applied'
        : 'You have <strong>' + n + ' Case Club code' + (n === 1 ? '' : 's') + '</strong>';
      html += '<button type="button" class="ccx__bar" data-ccx-toggle aria-expanded="' + state.open + '" aria-controls="ccx-list-' + uid + '">' +
        '<span class="ccx__tix" aria-hidden="true">🎟️</span><span class="ccx__label">' + label + '</span>' +
        '<span class="ccx__show">' + (state.open ? 'Hide' : 'Show') + '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></span></button>' +
        '<div class="ccx__panel" id="ccx-list-' + uid + '"' + (state.open ? '' : ' hidden') + '>' +
          '<ul class="ccx__codes">' + codes.map(function (v) { return codeRow(v, cart); }).join('') + '</ul>' +
          (state.msg ? '<p class="ccx__msg' + (state.msg.ok ? ' is-ok' : '') + '" role="status">' + esc(state.msg.text) + '</p>' : '') +
        '</div>';
    }
    html += cashRow(me, cart, uid);
    if (!state.cash.open && state.cash.msg) html += '<p class="ccx__msg ccx__msg--row' + (state.cash.msg.ok ? ' is-ok' : '') + '" role="status">' + esc(state.cash.msg.text) + '</p>';
    if (coins || wins.length) {
      var win = wins.length ? wins[state.win % wins.length] : null;
      var href = win && win.href ? win.href : '/account#case-club/earn';
      html += '<a class="ccx__earn" href="' + href + '" data-ccx-earn>' +
        '<span class="ccx__dot" aria-hidden="true"></span>' +
        '<span class="ccx__earn-t">' + (coins ? '<strong>Earn ' + fmtN(coins) + ' coins</strong> on this order' : 'Earn more coins') +
          (win ? '<span class="ccx__win" data-ccx-win> <span class="ccx__sep" aria-hidden="true">&middot;</span> ' + win.icon + ' ' + esc(win.text) + '</span>' : '') +
        '</span><span class="ccx__arrow" aria-hidden="true">&rarr;</span></a>';
    }
    return html ? '<div class="ccx' + (codes.length ? '' : ' ccx--slim') + '">' + html + '</div>' : '';
  }

  function render() {
    var any = false;
    slots.forEach(function (slot, i) {
      var h = build(i);
      if (slot.__ccx !== h) { slot.innerHTML = h; slot.__ccx = h; }
      slot.hidden = !h;
      if (h) any = true;
    });
    startRotation(any);
  }

  /* Rotate the quick win every few seconds (not for reduced-motion users, not when there's only one). */
  function startRotation(any) {
    if (rotTimer) { clearInterval(rotTimer); rotTimer = null; }
    if (!any || !state.me || !state.me.member) return;
    if (quickWins(state.me).length < 2) return;
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    rotTimer = setInterval(function () {
      if (document.hidden) return;
      var wins = quickWins(state.me); if (wins.length < 2) return;
      state.win = (state.win + 1) % wins.length;
      var w = wins[state.win];
      document.querySelectorAll('[data-ccx-earn]').forEach(function (a) {
        var el = a.querySelector('[data-ccx-win]'); if (!el) return;
        el.classList.add('is-out');
        setTimeout(function () {
          el.innerHTML = ' <span class="ccx__sep" aria-hidden="true">&middot;</span> ' + w.icon + ' ' + esc(w.text);
          a.setAttribute('href', w.href || '/account#case-club/earn');
          el.classList.remove('is-out');
        }, 220);
      });
      slots.forEach(function (s) { s.__ccx = null; }); // next full render rebuilds from state
    }, 4500);
  }

  function update(cart) {
    state.cart = cart;
    if (!cart || !cart.item_count) { render(); return; }
    if (state.me) render();
    loadMe().then(render);
  }

  /* ---- applying codes ---- */
  function postDiscount(list) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* Push the new cart into the theme's own renderer. */
  function afterChange(cart) {
    if (onCartPage) { window.location.reload(); return; }
    state.cart = cart;
    if (window.fcCart && typeof window.fcCart.refresh === 'function') window.fcCart.refresh();
    else render();
  }

  function fallback(code) {
    /* Storefront redirect: sets the discount cookie and comes back. Reliable, but reloads the page. */
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
  }

  function apply(code, opts) {
    opts = opts || {};
    if (state.busy) return Promise.resolve(false);
    state.busy = upper(code); state.msg = null; render();
    var before = [];
    return getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.discount_codes)) throw new Error('no-discount-support');
      opts.goPick = opts.pickUrl && !productInCart(cart, { useUrl: opts.pickUrl });
      before = cart.discount_codes.map(function (d) { return d.code; })
        .filter(function (c) { return upper(c) !== upper(code); });
      return postDiscount(before.concat([code]));
    }).then(function (cart) {
      if (!Array.isArray(cart.discount_codes)) throw new Error('no-discount-support');
      var hit = cart.discount_codes.filter(function (d) { return upper(d.code) === upper(code); })[0];
      if (!hit) throw new Error('no-discount-support');
      if (opts.goPick) {
        /* Free-product code for something not in the bag yet: it can't be "applicable" until the
           product is added, so keep it on the cart and send them to pick it. */
        state.busy = ''; state.msg = { ok: true, text: 'Code\'s on. Taking you to pick your freebie.' }; render();
        window.location.href = withRoot(opts.pickUrl);
        return true;
      }
      if (hit.applicable) {
        state.busy = ''; state.msg = { ok: true, text: opts.okText || 'Nice, that\'s on your bag.' };
        afterChange(cart);
        return true;
      }
      /* Didn't apply (min spend, wrong items, already used, not combinable). Put the bag back how it was. */
      return postDiscount(before).then(function (restored) {
        state.busy = '';
        state.msg = { ok: false, text: opts.failText || 'That code doesn\'t fit this bag yet. Check the small print, then try again.' };
        if (onCartPage) { state.cart = restored; render(); return false; }
        afterChange(restored);
        return false;
      });
    }).catch(function (err) {
      state.busy = '';
      if (err && err.message === 'no-discount-support') { fallback(code); return false; }
      state.msg = { ok: false, text: 'Hmm, that didn\'t work. Try again, or use the code at checkout.' };
      render();
      return false;
    });
  }

  function removeCode(code) {
    if (state.busy) return;
    state.busy = upper(code); state.msg = null; render();
    getCart().then(function (cart) {
      var keep = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return upper(c) !== upper(code); });
      return postDiscount(keep);
    }).then(function (cart) { state.busy = ''; afterChange(cart); })
      .catch(function () { state.busy = ''; state.msg = { ok: false, text: 'Couldn\'t remove that code. Try again.' }; render(); });
  }
  function redeem(pounds) {
    var cs = state.cash;
    if (cs.busy) return;
    cs.busy = true; cs.msg = null; render();
    var pv = preview();
    fetch('/apps/case-club/redeem-money' + (pv ? '?preview=' + encodeURIComponent(pv) : ''), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ pounds: pounds })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j.ok || !j.code) { var e = new Error(j.error || 'failed'); e.api = true; throw e; }
        return j;
      });
    }).then(function (j) {
      var fresh = {};
      Object.keys(state.me || {}).forEach(function (k) { fresh[k] = state.me[k]; });
      if (j.member) fresh.member = j.member;
      if (j.vouchers) fresh.vouchers = j.vouchers;
      storeMe(fresh);
      cs.busy = false; cs.open = false; cs.pick = 0;
      state.open = true;
      try { sessionStorage.setItem('ccx_open', '1'); } catch (e) {}
      coinRain();
      return apply(j.code, {
        okText: '£' + pounds + ' off, straight on your bag. Nice one!',
        failText: 'Your £' + pounds + ' code is saved in Your codes, but it doesn\'t fit this bag yet.'
      });
    }).catch(function (err) {
      cs.busy = false;
      var m = (err && err.message) || '';
      cs.msg = { ok: false, text: /not enough/i.test(m) ? 'You need a few more coins for that one. Try a smaller amount.'
        : /whole-pound/i.test(m) ? 'Pick one of the amounts above.'
        : /log in|join/i.test(m) ? 'Log in to your Case Club account to cash in.'
        : 'Couldn\'t cash in right now. Your coins are safe, try again in a sec.' };
      if (err && err.api) { try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {} }
      render();
    });
  }

  /* A light shower of coins over the drawer (or the page). Skipped for reduced-motion users. */
  function coinRain() {
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) { return; }
    var host = document.querySelector('.cart-drawer.is-open .cart-drawer__panel');
    var layer = document.createElement('div');
    layer.className = 'ccx-rain' + (host ? '' : ' ccx-rain--page');
    layer.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 18; i++) {
      var c = document.createElement('i');
      c.style.left = (Math.random() * 96) + '%';
      c.style.animationDelay = (Math.random() * 0.5).toFixed(2) + 's';
      c.style.animationDuration = (1 + Math.random() * 0.8).toFixed(2) + 's';
      var size = 12 + Math.round(Math.random() * 10);
      c.style.width = c.style.height = size + 'px';
      layer.appendChild(c);
    }
    (host || document.body).appendChild(layer);
    setTimeout(function () { layer.remove(); }, 2600);
  }

  window.fcCaseClubCart = { apply: apply, remove: removeCode, update: update, redeem: redeem };

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ccx-toggle]');
    if (t) {
      e.preventDefault();
      state.open = !state.open;
      try { sessionStorage.setItem('ccx_open', state.open ? '1' : '0'); } catch (err) {}
      if (!state.open) state.msg = null;
      render();
      return;
    }
    var a = e.target.closest('[data-ccx-apply]');
    if (a) { e.preventDefault(); apply(a.getAttribute('data-ccx-apply'), { pickUrl: a.getAttribute('data-ccx-pick') || '' }); return; }
    if (e.target.closest('[data-ccx-cash]')) { e.preventDefault(); state.cash.open = true; state.cash.pick = 0; state.cash.msg = null; render(); return; }
    if (e.target.closest('[data-ccx-cash-close]')) { e.preventDefault(); state.cash.open = false; state.cash.pick = 0; state.cash.msg = null; render(); return; }
    var chip = e.target.closest('[data-ccx-chip]');
    if (chip && !chip.disabled) { e.preventDefault(); state.cash.pick = parseInt(chip.getAttribute('data-ccx-chip'), 10) || 0; state.cash.msg = null; render(); return; }
    if (e.target.closest('[data-ccx-cash-back]')) { e.preventDefault(); state.cash.pick = 0; render(); return; }
    if (e.target.closest('[data-ccx-cash-go]')) { e.preventDefault(); if (state.cash.pick) redeem(state.cash.pick); return; }
    var r = e.target.closest('[data-ccx-remove]');
    if (r) { e.preventDefault(); removeCode(r.getAttribute('data-ccx-remove')); return; }
  });

  document.addEventListener('fc:cart:rendered', function (e) { update(e.detail && e.detail.cart); });

  /* The cart page is server-rendered (no drawer render on load), so fetch the cart ourselves there. */
  if (onCartPage) getCart().then(update).catch(function () {});
})();

